import Bluebird from 'bluebird';
import getTranslations from '../../../services/translations';
import { IErrorMessages } from './error-message';

let errorsCache: IErrorMessages;

function getErrorTranslations(): Bluebird<TranslationStrings['widget']> {
    return getTranslations('widget');
}

export default async function getErrorMessages(): Bluebird<IErrorMessages> {
    if (errorsCache) {
        return Bluebird.resolve(errorsCache);
    }

    const t = await getErrorTranslations();
    const result: IErrorMessages = {
        pickupTimeInPast: t['errors.pickupTimeInPast'],
        flightNumber: {
            notFound: t['errors.flightNumber.notFound']
        },
        flight: {
            noStepOverSelected: t['errors.flight.noStepOverSelected']
        },
        booking: {
            noOptions: t['errors.booking.noOptions'],
            noRoute: t['errors.booking.noRoute'],
            failed: t['errors.booking.failed']
        },
        other: {
            incomplete: t['errors.other.incomplete']
        }
    };

    errorsCache = result;
    return result;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/errors/error-storage.ts